import React from 'react'
import { Link as LinkS} from 'react-scroll';
import { Link as LinkR} from 'react-router-dom';
import './Footer.css'

function Footer() {
  return (
    <div className='footer-container'>
        <div className="footer-links">
            <div className="footer-link-wrapper">
                <div className="footer-link-items">
                    <h2>About me</h2>
                    <div>3 years VB.net software developer way back when I was in college.</div>
                    <div>but my First IT job experience is Front-end developer (currently).</div>
                    <div>The eagerness in me to enhance my knowledge about frond-end developing inspires me to study and learn more about it.</div>
                    <div>However, learning alone is not enough .</div>            
                    <div>"Job Experience is the best way to learn"</div>
                    <div>and I . Thank you.</div>
                </div>
             </div>
        </div>
        <section className="social-media">
            <div className="social-media-wrap">
                <div className="footer-logo">
                    <LinkS to="own" className="social-logo" spy={true} smooth={true} offset={-100} duration={500}>
                        <i class="fa-solid fa-p"></i>
                        <i class="fa-solid fa-r"></i>
                        <i class="fa-solid fa-microchip"></i>
                        <i class="fa-solid fa-g"></i>
                        <i class="fa-solid fa-d"></i>
                        <i class="fa-solid fa-m"></i>
                        <i class="fa-solid fa-r"></i>
                    </LinkS>
                </div>
                <small className="website-rights">PROGDRUMMER Ⓒ 2022</small>
                <div className="social-icons">
                   <LinkR className='social-icon-link facebook' to={{ pathname:'http://www.facebook.com/kdahirocmr122315'}} target='_blank' aria-label='Facebook'>
                   <i className='fab fa-facebook-f'></i>
                   </LinkR>
                   <LinkR className='social-icon-link instagram' to={{ pathname:'https://www.instagram.com/cue_beee/'}} target='_blank' aria-label='Instagram'>
                   <i className='fab fa-instagram'></i>
                   </LinkR>
                   <LinkR className='social-icon-link youtube' to={{ pathname:'https://www.youtube.com/channel/UCpqYEiOAfE-NlfJYGpLqGVQ'}} target='_blank' aria-label='youtube'>
                   <i className='fab fa-youtube'></i>
                   </LinkR>
                   <LinkR className='social-icon-link twitter' to={{ pathname:'https://twitter.com/kdahirocmr23'}} target='_blank' aria-label='twitter'>
                   <i className='fab fa-twitter'></i>
                   </LinkR>
                   <LinkR className='social-icon-link Linkedin' to={{ pathname:'https://www.linkedin.com/in/kobe-christian-dahiroc-470991146/'}} target='_blank' aria-label='linkedin'>
                   <i className='fab fa-linkedin'></i>
                   </LinkR>
                </div>
            </div>
        </section>
    </div>
  );
}

export default Footer;
